import React, { useState } from "react";
import {
  Modal,
  Box,
  Typography,
  Button,
  Tooltip,
  IconButton,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Input,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { useGetListaEdicoesQuery } from "shared/features/api/edicao/edicaoSlice";

const style = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: { xs: "90vw", sm: 400 },
  bgcolor: "background.paper",
  borderRadius: 2,
  boxShadow: 24,
  p: { xs: 2, sm: 4 },
  maxHeight: "90vh",
  overflowY: "auto",
};

interface FormFilterProps {
  edicao?: string;
  setEdicao?: (value: any) => void;
  etapa?: string;
  setEtapa?: (value: string) => void;
  statusEtapa?: string;
  setStatusEtapa?: (value: string) => void;
  situacao?: string;
  setSituacao?: (value: string) => void;
  trilha?: string;
  setTrilha?: (value: string) => void;
}

export const FormFilter: React.FC<FormFilterProps> = ({
  edicao,
  setEdicao,
  etapa,
  setEtapa,
  statusEtapa,
  setStatusEtapa,
  situacao,
  setSituacao,
  trilha,
  setTrilha,
}) => {
  const [open, setOpen] = useState(false);

  const [formEdicao, setFormEdicao] = useState(edicao ?? "");
  const [formEtapa, setFormEtapa] = useState(etapa ?? "");
  const [formStatusEtapa, setFormStatusEtapa] = useState(statusEtapa ?? "");
  const [formSituacao, setFormSituacao] = useState(situacao ?? "");
  const [formTrilha, setFormTrilha] = useState(trilha ?? "");

  const { data: edicoes } = useGetListaEdicoesQuery();

  const handleOpen = () => {
    setFormEdicao(edicao ?? "");
    setFormEtapa(etapa ?? "");
    setFormStatusEtapa(statusEtapa ?? "");
    setFormSituacao(situacao ?? "");
    setFormTrilha(trilha ?? "");
    setOpen(true);
  };

  const handleClose = () => setOpen(false);

  const handleAplicar = () => {
    setEdicao?.(formEdicao);
    setEtapa?.(formEtapa);
    setStatusEtapa?.(formStatusEtapa);
    setSituacao?.(formSituacao);
    setTrilha?.(formTrilha);
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Filtrar">
        <IconButton onClick={handleOpen}>
          <FilterListIcon />
        </IconButton>
      </Tooltip>

      <Modal open={open} onClose={handleClose}>
        <Box sx={style}>
          <Typography variant="h6">Filtros Avançados</Typography>

          {setEdicao && (
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>Edição</InputLabel>
              <Select
                value={formEdicao ?? ""}
                label="Edição"
                onChange={(e) => setFormEdicao(e.target.value)}
              >
                {edicoes?.map((edicao) => (
                  <MenuItem key={edicao.nome} value={edicao.nome}>
                    {edicao.nome}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          )}

          {setSituacao && (
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>Situação</InputLabel>
              <Select
                value={formSituacao ?? ""}
                label="Situação"
                onChange={(e) => setFormSituacao(e.target.value)}
              >
                <MenuItem value="">Todas</MenuItem>
                <MenuItem value="INSCRITO">Inscrito</MenuItem>
                <MenuItem value="CONTRATADO">Contratado</MenuItem>
                <MenuItem value="REJEITADO">Rejeitado</MenuItem>
              </Select>
            </FormControl>
          )}

          {setEtapa && (
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>Etapa</InputLabel>
              <Select
                value={formEtapa ?? ""}
                label="Etapa"
                onChange={(e) => setFormEtapa(e.target.value)}
                disabled={!formEdicao}
              >
                {formEdicao &&
                  edicoes
                    ?.find((e) => e.nome === formEdicao)
                    ?.etapas?.map((etapa: any) => (
                      <MenuItem key={etapa.nome} value={etapa.nome}>
                        {etapa.nome}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>
          )}

          {setStatusEtapa && (
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>Status da Etapa</InputLabel>
              <Select
                value={formStatusEtapa ?? ""}
                label="Status da Etapa"
                onChange={(e) => setFormStatusEtapa(e.target.value)}
                disabled={!formEtapa}
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="ANDAMENTO">Em andamento</MenuItem>
                <MenuItem value="APROVADO">Aprovado</MenuItem>
                <MenuItem value="REPROVADO">Reprovado</MenuItem>
                <MenuItem value="AGUARDANDO">Aguardando</MenuItem>
              </Select>
            </FormControl>
          )}

          {setTrilha && (
            <FormControl fullWidth sx={{ mt: 2 }}>
              <InputLabel>Trilha</InputLabel>
              <Select
                value={formTrilha ?? ""}
                label="Trilha"
                onChange={(e) => setFormTrilha(e.target.value)}
              >
                <MenuItem value="">Todos</MenuItem>
                <MenuItem value="FULLSTACK">Fullstack</MenuItem>
                <MenuItem value="RPA">RPA</MenuItem>
                <MenuItem value="DADOS">Dados</MenuItem>
                <MenuItem value="QA">QA</MenuItem>
              </Select>
            </FormControl>
          )}

          <Box mt={4} display="flex" justifyContent="flex-end" gap={2}>
            <Button onClick={handleClose}>Cancelar</Button>
            <Button variant="contained" onClick={handleAplicar}>
              Aplicar
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
